import { FC } from "react"
import {
  Box,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Switch,
} from "@mui/material"
import { useAppDispatch, useAppSelector } from "@/modules/app/hooks"
import { OSINT } from "../../interfaces"
import { QUERY_TYPES } from "../../constants"
import { getSherlokState, setFilters, setAutoRefresh } from "../../store"

const STATUS_OPTIONS: { value: OSINT.Status | ""; label: string }[] = [
  { value: "", label: "Любой" },
  { value: "PENDING", label: "Ожидание" },
  { value: "QUEUED", label: "В очереди" },
  { value: "SENT", label: "Отправлен" },
  { value: "SEARCHING", label: "Поиск" },
  { value: "AWAITING_INPUT", label: "Требует действия" },
  { value: "COMPLETED", label: "Готово" },
  { value: "FAILED", label: "Ошибка" },
  { value: "TIMED_OUT", label: "Таймаут" },
]

export const QueriesToolbar: FC = () => {
  const dispatch = useAppDispatch()
  const { filters, autoRefresh } = useAppSelector(getSherlokState)

  return (
    <Box display="flex" gap={2} alignItems="center" mb={1}>
      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Статус</InputLabel>
        <Select
          label="Статус"
          value={filters.status ?? ""}
          onChange={(e) =>
            dispatch(
              setFilters({
                ...filters,
                status: (e.target.value || undefined) as
                  | OSINT.Status
                  | undefined,
              }),
            )
          }
        >
          {STATUS_OPTIONS.map((o) => (
            <MenuItem key={o.value} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel>Тип</InputLabel>
        <Select
          label="Тип"
          value={filters.type ?? ""}
          onChange={(e) =>
            dispatch(
              setFilters({
                ...filters,
                type: (e.target.value || undefined) as
                  | OSINT.PayloadType
                  | undefined,
              }),
            )
          }
        >
          <MenuItem value="">Любой</MenuItem>
          {QUERY_TYPES.map((t) => (
            <MenuItem key={t.type} value={t.type}>
              {t.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControlLabel
        control={
          <Switch
            checked={autoRefresh}
            onChange={(_, v) => dispatch(setAutoRefresh(v))}
          />
        }
        label="Авто-обновление (5с)"
      />
    </Box>
  )
}
